import { Link } from "react-router-dom";

interface PolicyAcceptanceProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Optional id so a label/for pairing is unique when several render on a page. */
  id?: string;
  className?: string;
}

/**
 * Mandatory "I accept the policies" checkbox shown before any purchase.
 *
 * The policy names are clickable links (open in a new tab so the checkout is not
 * lost). Purchase buttons must stay disabled until `checked` is true — this
 * component only reports state; the parent enforces the gate.
 */
export function PolicyAcceptance({
  checked,
  onChange,
  id = "policy-acceptance",
  className = "",
}: PolicyAcceptanceProps) {
  return (
    <label
      htmlFor={id}
      className={`flex items-start gap-2.5 cursor-pointer select-none text-left ${className}`}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 size-4 shrink-0 rounded border-stone-300 text-primary focus:ring-2 focus:ring-primary cursor-pointer accent-primary"
      />
      <span className="text-[11px] leading-relaxed text-stone-600">
        I have read and agree to the{" "}
        <Link
          to="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-semibold underline underline-offset-2 hover:text-primary/80"
          onClick={(e) => e.stopPropagation()}
        >
          Terms &amp; Conditions
        </Link>
        ,{" "}
        <Link
          to="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-semibold underline underline-offset-2 hover:text-primary/80"
          onClick={(e) => e.stopPropagation()}
        >
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          to="/refund-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-primary font-semibold underline underline-offset-2 hover:text-primary/80"
          onClick={(e) => e.stopPropagation()}
        >
          Refund Policy
        </Link>
        .
        <span className="block text-stone-400 mt-0.5">
          আমি শর্তাবলি, প্রাইভেসি নীতিমালা ও ফেরত নীতিমালা পড়েছি এবং সম্মত আছি।
        </span>
      </span>
    </label>
  );
}
